import e from"styled-components";const t=e.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	column-gap: 8px;
	align-items: center;
`,i=e.div`
	display: flex;
	flex-flow: row;
	gap: 12px;
	flex: 0 0 40%;
	min-width: 0;
	overflow: hidden;
`,l=e.div`
	color: #a4a4a4;
	font-family: 'SF Pro Display';
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 19px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100%;
	text-align: center;
`,o=e.div`
	display: flex;
	align-items: center;
	gap: 16px;
	align-self: stretch;
	color: ${({theme:e})=>e.text.gray};
	font-family: 'SF Pro Display';
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 19px;
	flex: 0 0 38%;
	justify-content: flex-end;
	min-width: 0;
	overflow: hidden;
`,n=e.div`
	display: flex;
	align-items: center;
	gap: 5px;
	align-self: stretch;
	color: ${({theme:e})=>e.text.gray};
	font-family: 'SF Pro Display';
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 19px;
`,a=e.div`
	color: ${({theme:e})=>e.text.title};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"11px":"18px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"11.333px":"21px"};

	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`;e.div`
	display: flex;
	align-items: baseline;
	gap: 0px 6px;
	align-self: stretch;
	align-items: center;
	flex-wrap: wrap;
	color: ${({theme:e})=>e.text.text};
	font-family: 'SF Pro Display';
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 19px;
`,e.div`
	color: ${({theme:e})=>e.text.text};
	font-family: 'SF Pro Display';
	font-size: 13px;
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"8px":"19px"};
`;const p=e.div`
	display: flex;
	align-items: center;
	gap: 8px;
	color: #adadad;
	font-family: 'SF Pro Display';
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 19px; /* 158.333% */
`,f=e.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;export{p as LikesAndComments,f as LikesAndCommentsWrapper,t as ListContent,n as Modified,o as ModifiedWrapper,l as SpaceAndAuthor,a as Title,i as TitleWrapper};
